"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var AffilatesSmtpCfgCtl = /** @class */ (function (_super) {
    __extends(AffilatesSmtpCfgCtl, _super);
    function AffilatesSmtpCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    AffilatesSmtpCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            smtp_server: "",
            smtp_port: 0,
            smtp_user: "",
            smtp_password: "",
            smtp_use_ssl: false,
            smtp_from_email: ""
        };
    };
    AffilatesSmtpCfgCtl.prototype.LoadData = function (pprogram_key, onDone) {
        var _this = this;
        webAApi_1.DetailsPProgramSmtpConfigGet.exec({ pprogram_id: pprogram_key }, function (resp) {
            _this.DATA.smtp_server = resp.smtp_server;
            _this.DATA.smtp_port = resp.smtp_port;
            _this.DATA.smtp_user = resp.smtp_user;
            _this.DATA.smtp_password = resp.smtp_password;
            _this.DATA.smtp_use_ssl = resp.smtp_use_ssl;
            _this.DATA.smtp_from_email = resp.smtp_from_email;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AffilatesSmtpCfgCtl.prototype.EditData = function (editData, onDone) {
        var _this = this;
        webAApi_1.DoEditPProgramSmtpConfig.exec({
            data: {
                smtp_server: editData.smtp_server,
                smtp_port: editData.smtp_port,
                smtp_password: editData.smtp_password,
                smtp_use_ssl: editData.smtp_use_ssl,
                smtp_from_email: editData.smtp_from_email,
                smtp_user: editData.smtp_user,
                pprogram_id: editData.pprogram_id
            }
        }, function (resp) {
            _this.DATA.smtp_server = editData.smtp_server;
            _this.DATA.smtp_port = editData.smtp_port;
            _this.DATA.smtp_user = editData.smtp_user;
            _this.DATA.smtp_password = editData.smtp_password;
            _this.DATA.smtp_use_ssl = editData.smtp_use_ssl;
            _this.DATA.smtp_from_email = editData.smtp_from_email;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return AffilatesSmtpCfgCtl;
}(BaseController_1.BaseController));
exports.AffilatesSmtpCfgCtl = AffilatesSmtpCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ctl/AffilateSmtpCfgCtl.ts
// module id = 989
// module chunks = 0